import { createTheme } from "@mui/material/styles";

let theme = createTheme({
  palette: {
    primary: {
      main: "rgb(var(--primary-color, 25, 118, 210))",
      contrastText: "#fff",
    },
  },

  typography: {
    fontFamily: "Poppins, Roboto, Arial, sans-serif",
  },
});

theme = createTheme(theme, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 400,
          borderRadius: "4px",
          padding: "4px 10px",
          fontSize: "1.1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
            padding: "4px 10px",
          },
        },

        containedPrimary: {
          backgroundColor: "#5d78ff",
          color: "white",
          "&:hover": {
            backgroundColor: "#5d78ff",
          },
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
        },
      },
    },

    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {
          "&:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "&:hover:not(.Mui-disabled):before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiSelect: {
      styleOverrides: {
        standard: {
          "&.MuiInput-root:before, & .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
          "&:hover:not(.Mui-disabled, .Mui-error) .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0,0,0,0.1)",
          },
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "1.1rem",
          fontWeight: 500,

          [theme.breakpoints.down("sm")]: {
            fontSize: "1rem",
          },
        },
      },
    },

    MuiStepLabel: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",
          fontWeight: 500,

          [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
          },
        },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 600,
          padding: 0,

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },

    MuiPickersDay: {
      styleOverrides: {
        root: {
          fontSize: "1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },
    MuiDayCalendar: {
      styleOverrides: {
        weekDayLabel: {
          fontSize: "1rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "0.9rem",
          },
        },
      },
    },

    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          fontSize: "1.3rem",

          [theme.breakpoints.down("sm")]: {
            fontSize: "1.1rem",
          },
        },
      },
    },
  },
});

export default theme;
